function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "14",
  viewBox: "0 0 24 14",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "bike-icon2",
  transform: "translate(0 -1)",
  fill: "#545454"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.08 1.324a.468.468 0 01-.261.54l-.08.028-1.368.342.462 1.252.006.017 1.182 3.212a4.219 4.219 0 11-.878.324l-.893-2.42-4.811 6.474-.057.063-.064.05-.072.039-.076.025-.079.011h-1.93a4.219 4.219 0 11-1.735-3.898l1.196-1.331-.897-2.208h-.881c-.26 0-.469-.224-.469-.5 0-.246.166-.45.384-.492l.085-.008h2.812c.26 0 .469.224.469.5 0 .245-.166.45-.384.492l-.085.008h-.919l.692 1.702 6.356-2.188-.294-.8a.939.939 0 01.544-1.199l.108-.034 1.368-.342a.47.47 0 01.569.34v.001zM4.969 7.53a3.282 3.282 0 103.248 3.75H4.969a.47.47 0 01-.397-.72l.048-.062 2.173-2.414a3.266 3.266 0 00-1.824-.554zm14.062 0c-.234 0-.462.025-.683.071l1.123 3.048a.468.468 0 01-.843.401l-.037-.076-1.122-3.049a3.282 3.282 0 101.562-.395zM7.489 8.71l-1.468 1.633h2.196a3.264 3.264 0 00-.728-1.633zm1.525-1.694l-.892.992a4.21 4.21 0 011.04 2.335h1.203l-1.35-3.327h-.001zm6.097-2.436l-5.33 1.834 1.402 3.449 3.928-5.283z",
  id: "Shape"
})))));